"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[944],{

/***/ 944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Internals_ContentComposer; }
});

// UNUSED EXPORTS: ContentComposer

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/dom-serializer/lib/esm/index.js + 10 modules
var esm = __webpack_require__(7490);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/isValidHttpUrl.ts
function isValidHttpUrl(string) {
    var url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

// EXTERNAL MODULE: ./src/components/Internals/CustomComponentComposer/index.tsx + 5 modules
var CustomComponentComposer = __webpack_require__(5001);
// EXTERNAL MODULE: ./src/components/Internals/NewsContent/styles.tsx
var styles = __webpack_require__(2657);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Internals/ContentComposer/index.tsx
















var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function ContentComposer(_param) {
    var tmp = _param.as, Tag = tmp === void 0 ? react.Fragment : tmp, tipo = _param.tipo, _valor = _param.valor, valor = _valor === void 0 ? undefined : _valor, _url = _param.url, url = _url === void 0 ? undefined : _url, _target = _param.target, target = _target === void 0 ? undefined : _target, _rel = _param.rel, rel = _rel === void 0 ? undefined : _rel, _atributos = _param.atributos, atributos = _atributos === void 0 ? undefined : _atributos, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "as",
        "tipo",
        "valor",
        "url",
        "target",
        "rel",
        "atributos"
    ]);
    var ClientSideParseHtml = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 8287).then(__webpack_require__.bind(__webpack_require__, 8287));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(8287)
                ];
            }
        },
        ssr: false
    });
    var options = {
        // eslint-disable-next-line consistent-return
        replace: function(domNode) {
            if (domNode.attribs && domNode.name === "blockquote" && domNode.children.find(function(e) {
                return e.name === "p" || e.type === "text";
            })) {
                var domNodeAlter = domNode;
                domNodeAlter.attribs.className = "blockquote";
                var stringDom = (0,esm/* default */.Z)(domNodeAlter);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,html_react_parser/* default */.ZP)(stringDom)
                });
            }
            if (domNode.attribs && (domNode.name === "blockquote" || domNode.name === "iframe")) {
                if (!domNode.children.find(function(e) {
                    return e.name === "p";
                })) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSideParseHtml, {
                        domNode: domNode
                    });
                }
            }
            if (domNode.attribs && domNode.name === "script") {
                var ref, ref1;
                var telegramProps = {
                    "data-telegram-post": ((ref = domNode.attribs) === null || ref === void 0 ? void 0 : ref["data-telegram-post"]) || "",
                    "data-width": ((ref1 = domNode.attribs) === null || ref1 === void 0 ? void 0 : ref1["data-width"]) || ""
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), (0,_object_spread/* default */.Z)({
                    async: domNode.attribs.async,
                    src: domNode.attribs.src,
                    strategy: "afterInteractive"
                }, telegramProps), domNode.attribs.src);
            }
        }
    };
    var parseIframe = function(value) {
        return (0,html_react_parser/* default */.ZP)(value, options);
    };
    var elementParser = function(type) {
        var ContainerTag = react.Fragment;
        var ParentTag = react.Fragment;
        var GrandparentTag = react.Fragment;
        var linkProps = {};
        var nextLinkProps = {};
        var attrProps = {};
        if (type === "link") {
            var isInternalLink = false;
            if (isValidHttpUrl(url)) {
                var origin = new URL(url).origin;
                isInternalLink = origin === publicRuntimeConfig.NEXT_PUBLIC_URL;
            }
            ParentTag = "a";
            linkProps = {
                href: url,
                rel: rel,
                target: target
            };
            if (isInternalLink) {
                GrandparentTag = (link_default());
                Object.assign(nextLinkProps, {
                    href: url,
                    prefetch: false,
                    passHref: true
                });
                Object.assign(linkProps, {
                    target: "_self"
                });
            }
        }
        if (type === "lista") ContainerTag = "li";
        if (type === "tabela") ParentTag = styles/* TableContainer */.xJ;
        if (atributos) {
            atributos.forEach(function(attr) {
                Object.assign(attrProps, (0,_define_property/* default */.Z)({}, attr.nome, attr.valor));
            });
        }
        var element = valor === null || valor === void 0 ? void 0 : valor.map(function(child, index) {
            if (typeof child === "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ContainerTag !== react.Fragment && otherProps, ContainerTag !== react.Fragment && (0,html_react_parser/* attributesToProps */.e_)(attrProps)), {
                children: child
            }), index);
            if ((0,CustomComponentComposer/* isCustomComponent */.m)(child)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ContainerTag !== react.Fragment && otherProps, ContainerTag !== react.Fragment && (0,html_react_parser/* attributesToProps */.e_)(attrProps)), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomComponentComposer/* default */.Z, {
                    partHtml: child,
                    index: index
                }, index)
            }), index);
            return /*#__PURE__*/ (0,react.createElement)(ContainerTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ContainerTag !== react.Fragment && otherProps), {
                key: index
            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComposer, {
                as: child === null || child === void 0 ? void 0 : child.tag,
                tipo: child === null || child === void 0 ? void 0 : child.tipo,
                valor: child === null || child === void 0 ? void 0 : child.valor,
                url: child === null || child === void 0 ? void 0 : child.url,
                target: child === null || child === void 0 ? void 0 : child.target,
                rel: child === null || child === void 0 ? void 0 : child.rel,
                atributos: child === null || child === void 0 ? void 0 : child.atributos
            }));
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GrandparentTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextLinkProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Tag !== react.Fragment && otherProps, Tag !== react.Fragment && (0,html_react_parser/* attributesToProps */.e_)(attrProps)), {
                    children: element
                }))
            }))
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tipo !== "html" ? elementParser(tipo) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: typeof (valor === null || valor === void 0 ? void 0 : valor[0]) === "string" && parseIframe(valor === null || valor === void 0 ? void 0 : valor[0])
        })
    });
}
/* harmony default export */ var Internals_ContentComposer = (ContentComposer);


/***/ }),

/***/ 5001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomComponentComposer; },
  "m": function() { return /* binding */ isCustomComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/contexts/pageData.tsx
var pageData = __webpack_require__(804);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
// EXTERNAL MODULE: ./src/components/Layout/ProsAndCons/index.tsx
var ProsAndCons = __webpack_require__(4879);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
;// CONCATENATED MODULE: ./src/components/Layout/ContentBlockquote/index.tsx


function ContentBlockquote(param) {
    var text = param.text, _author = param.author, author = _author === void 0 ? "" : _author;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var contentBlockquoteSpan = currentSpan && currentSpan.startChild({
        op: "contentBlockquote"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
        className: "blockquote",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text || text[0]
            }),
            !!author && /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                children: [
                    "— ",
                    author
                ]
            }),
            contentBlockquoteSpan && contentBlockquoteSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-image-gallery/build/image-gallery.js
var image_gallery = __webpack_require__(7274);
var image_gallery_default = /*#__PURE__*/__webpack_require__.n(image_gallery);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Internals/Gallery/styles.tsx






var variants = {
    GalleryContainer: {
        isOpen: {
            true: "[&>div>div>div.image-gallery-slide-wrapper]:cursor-default",
            false: "[&>div>div>div>div>div_.image-gallery-slide>img]:h-full"
        }
    },
    GalleryImageContainer: {
        isFirst: {
            true: "",
            false: "hidden"
        }
    },
    GalleryCaptionContainer: {
        isOpen: {
            true: "bg-transparent [&>p]:text-mglGray50",
            false: ""
        }
    },
    GalleryNavButton: {
        right: {
            true: "right-6",
            false: ""
        },
        left: {
            true: "left-6",
            false: ""
        }
    }
};
var GalleryPlaceholder = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "mb-6 min-h-[calc(85vh-100px)] rounded-b bg-mglGray100 [@media_only_screen_and_(max-height:700px)]:min-h-[calc(65vh-64px)] [@media_only_screen_and_(max-height:750px)]:min-h-[calc(60vh-80px)] [@media_only_screen_and_(max-height:950px)_and_(max-width:767px)]:min-h-[calc(50vh-80px)]"
    }, rest), {
        children: children
    }));
};
var GalleryContainer = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, isOpen = _param.isOpen, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isOpen"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,className/* default */.Z)("min-h-[70%] [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button.active]:opacity-100 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:m-0 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:h-[6px] [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:w-[30px] [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:rounded [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:bg-mglGray50 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:p-0 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:opacity-40 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div>button]:hover:bg-mglBlue400 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div]:flex [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div]:flex-wrap [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div]:items-center [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div]:justify-center [&>div>div>.image-gallery-slide-wrapper>.image-gallery-bullets>div]:gap-2 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:bottom-3 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:left-3 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:right-[initial] [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:top-[initial] [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:rounded-2xl [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:bg-mglGray50 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:px-4 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:py-2 [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:text-xs [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:leading-none [&>div>div>.image-gallery-slide-wrapper>.image-gallery-index]:text-mglGray900 [&>div>div>.image-gallery-slide-wrapper]:cursor-pointer [&>div]:h-full [&>div_.image-gallery-image]:aspect-video [&>div_.image-gallery-image]:bg-mglGray900 [&>div_.image-gallery-thumbnail-image]:h-[63px] [&>div_.image-gallery-thumbnail-image]:w-auto [&>div_.image-gallery-thumbnails>nav>button.active]:opacity-100 [&>div_.image-gallery-thumbnails>nav>button]:mx-[6px] [&>div_.image-gallery-thumbnails>nav>button]:my-1 [&>div_.image-gallery-thumbnails>nav>button]:aspect-[127/81] [&>div_.image-gallery-thumbnails>nav>button]:h-[63px] [&>div_.image-gallery-thumbnails>nav>button]:overflow-hidden [&>div_.image-gallery-thumbnails>nav>button]:border-0 [&>div_.image-gallery-thumbnails>nav>button]:bg-mglGray900 [&>div_.image-gallery-thumbnails>nav>button]:opacity-40 [&>div_.image-gallery-thumbnails>nav>button]:transition-all [&>div_.image-gallery-thumbnails>nav>button]:duration-300 [&>div_.image-gallery-thumbnails>nav>button]:ease-ease hover:[&>div_.image-gallery-thumbnails>nav>button]:opacity-80 [&>div_.image-gallery-thumbnails]:fixed [&>div_.image-gallery-thumbnails]:left-0 [&>div_.image-gallery-thumbnails]:top-[80%] [&>div_.image-gallery-thumbnails]:z-[4] [&>div_.image-gallery-thumbnails]:w-full [&>div_.image-gallery-thumbnails]:max-w-[705px] [&>div_.image-gallery-thumbnails]:overflow-hidden [&>div_.image-gallery-thumbnails]:rounded tablet:[&>div_.image-gallery-thumbnails]:left-[60px] desktop:[&>div_.image-gallery-thumbnails]:left-[initial] [@media_only_screen_and_(max-height:700px)]:min-h-full [@media_only_screen_and_(min-height:701px)_and_(max-height:750px)]:min-h-[90%] [@media_only_screen_and_(min-height:751px)_and_(max-height:800px)]:min-h-[80%] [@media_only_screen_and_(min-height:801px)_and_(max-height:950px)]:min-h-[initial]", variants.GalleryContainer.isOpen[isOpen.toString()])
    }, rest), {
        children: children
    }));
});
var GalleryImageContainer = function(_param) {
    var children = _param.children, isFirst = _param.isFirst, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isFirst"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,className/* default */.Z)("", variants.GalleryImageContainer.isFirst[isFirst.toString()])
    }, rest), {
        children: children
    }));
};
var GalleryCaptionContainer = function(_param) {
    var children = _param.children, _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? undefined : _isOpen, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isOpen"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,className/* default */.Z)("mb-6 flex flex-col justify-center rounded-b bg-mglGray100 px-0 py-2", isOpen != null && variants.GalleryCaptionContainer.isOpen[isOpen.toString()])
    }, rest), {
        children: children
    }));
};
var GalleryCaptionText = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "text-center text-sm text-mglGray900"
    }, rest), {
        children: children
    }));
};
var GalleryCredits = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "text-center text-sm text-mglGray900 opacity-40"
    }, rest), {
        children: children
    }));
};
var GalleryNavButton = function(_param) {
    var children = _param.children, _left = _param.left, left = _left === void 0 ? undefined : _left, _right = _param.right, right = _right === void 0 ? undefined : _right, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "left",
        "right"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,className/* default */.Z)("absolute top-[50%] z-[4] flex h-11 w-11 cursor-pointer items-center justify-center rounded-half border-none bg-mglBlue400 transition-all duration-300 ease-ease hover:bg-mglGray50 [&>svg]:text-2xl [&>svg]:text-mglGray50 [&>svg]:hover:text-mglBlue400", left != null && variants.GalleryNavButton.left[left.toString()], right != null && variants.GalleryNavButton.right[right.toString()])
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var styles = ({
    GalleryPlaceholder: GalleryPlaceholder,
    GalleryImageContainer: GalleryImageContainer,
    GalleryContainer: GalleryContainer,
    GalleryCaptionContainer: GalleryCaptionContainer,
    GalleryCaptionText: GalleryCaptionText,
    GalleryCredits: GalleryCredits
});

// EXTERNAL MODULE: ./src/hooks/useOutsideClickRef.ts
var useOutsideClickRef = __webpack_require__(6425);
// EXTERNAL MODULE: ./src/assets/svg/ctlogo.svg
var ctlogo = __webpack_require__(3535);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/styles/css/image-gallery.css
var css_image_gallery = __webpack_require__(4153);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Internals/Gallery/ModalGallery/index.tsx









function ModalGallery(param) {
    var valor = param.valor, index = param.index, setIndex = param.setIndex, isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var variants = {
        ModalContainer: {
            isOpen: {
                true: "opacity-100 z-10 overflow-hidden",
                false: "opacity-0 z-[-1]"
            }
        }
    };
    var modalRef = (0,useOutsideClickRef/* default */.Z)({
        setIsOpen: setIsOpen
    });
    var items = valor === null || valor === void 0 ? void 0 : valor.map(function(currentImage) {
        var item = {
            original: currentImage.url,
            originalWidth: currentImage.dimensao.largura,
            originalHeight: currentImage.dimensao.altura,
            originalAlt: currentImage.alt,
            originalTitle: currentImage.titulo,
            thumbnail: currentImage.thumbnail,
            thumbnailAlt: currentImage.legenda,
            loading: "lazy"
        };
        return item;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,className/* default */.Z)("fixed left-0 top-0 h-full w-full overflow-auto bg-black/90 transition-all duration-300 ease-ease [&>svg]:cursor-pointer [&>svg]:text-2xl", variants.ModalContainer.isOpen[isOpen.toString()]),
        role: "dialog",
        "aria-modal": isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-8 top-[72px] z-[4] cursor-pointer text-4xl tablet:top-8",
                "data-testid": "modal-close",
                onClick: function() {
                    return setIsOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    icon: "mdi:close",
                    color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-0 -mb-16 mt-16 hidden items-center justify-center tablet:flex [@media_only_screen_and_(max-height:750px)]:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ctlogo/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative m-auto flex h-full min-h-[336px] w-full max-w-[760px] items-center justify-center rounded bg-transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryContainer, {
                    isOpen: true,
                    ref: modalRef,
                    children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_gallery_default()), {
                                startIndex: index,
                                items: items,
                                useTranslate3D: true,
                                lazyLoad: true,
                                showFullscreenButton: false,
                                showPlayButton: false,
                                showThumbnails: true,
                                showIndex: true,
                                renderLeftNav: function(onClick) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryNavButton, {
                                        left: true,
                                        onClick: onClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            icon: "mdi:chevron-right",
                                            style: {
                                                transform: "rotate(0.5turn)"
                                            }
                                        })
                                    });
                                },
                                renderRightNav: function(onClick) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryNavButton, {
                                        right: true,
                                        onClick: onClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            icon: "mdi:chevron-right"
                                        })
                                    });
                                },
                                onSlide: function(currentIndex) {
                                    return setIndex(currentIndex);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GalleryCaptionContainer, {
                                isOpen: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryCaptionText, {
                                        children: valor[index].legenda
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryCredits, {
                                        children: valor[index].credito
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/Gallery/index.tsx





function Gallery(param) {
    var valor = param.valor;
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var items = valor === null || valor === void 0 ? void 0 : valor.map(function(currentImage) {
        var item = {
            original: currentImage.url,
            originalWidth: currentImage.dimensao.largura,
            originalHeight: currentImage.dimensao.altura,
            originalAlt: currentImage.alt,
            originalTitle: currentImage.titulo,
            thumbnail: currentImage.thumbnail,
            thumbnailAlt: currentImage.legenda,
            loading: "lazy"
        };
        return item;
    });
    return (valor === null || valor === void 0 ? void 0 : valor.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryContainer, {
                isOpen: isOpen,
                children: !isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_gallery_default()), {
                            startIndex: index,
                            items: items,
                            useTranslate3D: true,
                            lazyLoad: true,
                            showThumbnails: false,
                            showFullscreenButton: false,
                            showPlayButton: false,
                            showBullets: false,
                            showIndex: !isOpen,
                            showNav: !isOpen,
                            renderLeftNav: function(onClick) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryNavButton, {
                                    "data-testid": "inline-previous",
                                    left: true,
                                    onClick: onClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1em",
                                        height: "1em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(180deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                });
                            },
                            renderRightNav: function(onClick) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryNavButton, {
                                    "data-testid": "inline-next",
                                    right: true,
                                    onClick: onClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1em",
                                        height: "1em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(360deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                });
                            },
                            onClick: function() {
                                return setIsOpen(true);
                            },
                            onSlide: function(currentIndex) {
                                return setIndex(currentIndex);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GalleryCaptionContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryCaptionText, {
                                    children: valor[index].legenda
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryCredits, {
                                    children: valor[index].credito
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryPlaceholder, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGallery, {
                valor: valor,
                index: index,
                setIndex: setIndex,
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/IFrameYoutube/index.tsx
var IFrameYoutube = __webpack_require__(3251);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
;// CONCATENATED MODULE: ./src/components/Layout/SocialMediaEmbed/index.tsx




function SocialMediaEmbed(param) {
    var id = param.id, type = param.type, hideDataConversation = param.hideDataConversation, category = param.category, author = param.author;
    var AutoResize = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            id: "autoResize",
            type: "text/javascript",
            children: '\n      const target = document.getElementById(\'content-news\');\n      const config = { childList: true, subtree: true };\n      const callback = (mutationList, observer) => {\n        for (const mutation of mutationList) {\n          if (mutation.type === "childList" && mutation.addedNodes?.[0]?.childNodes?.[0]) {\n            const iframeId = mutation.addedNodes[0].childNodes[0].id;\n            autoResize(iframeId);\n          }\n        }\n      };\n\n      const observer = new MutationObserver(callback);\n      observer.observe(target, config);\n\n      async function autoResize(iframeId) {\n        let newHeight;\n        let counter = 0;\n        const selectedIframe = document?.getElementById(iframeId);\n\n        const refreshIframe = setInterval(() => {\n          counter++\n          if (selectedIframe) {\n          newHeight = selectedIframe.contentWindow?.document?.body.scrollHeight + 40 > 360 ? selectedIframe.contentWindow.document.body.scrollHeight + 40 : selectedIframe.height;\n          if (selectedIframe.height !== newHeight) selectedIframe.height = newHeight + "px";\n          }\n          counter === 24 && clearInterval(refreshIframe);\n        }, 1000)\n      }\n'
        });
    };
    var getAuthor = function() {
        return author || "_";
    };
    var getEmbed = function() {
        switch(type){
            case "instagram":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" width="640" height="360" srcdoc=\'<blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="https://www.instagram.com/').concat(category || "p", "/").concat(id, '/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"></blockquote> <script async src="//www.instagram.com/embed.js"></script>\'></iframe>');
            case "twitter":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" width="640" height="360" srcdoc=\'<blockquote class="twitter-tweet tw-align-center" ').concat(hideDataConversation ? 'data-conversation="none" ' : "", '><a href="https://twitter.com/_/status/').concat(id, '"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\'>\n              </iframe>\n              ');
            case "reddit":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" srcdoc=\'<blockquote class="reddit-embed-bq" style="height:316px" data-embed-height="316">      <a href="https://www.reddit.com/r/').concat(id, '/"></a> </blockquote><script async="" src="https://embed.reddit.com/widgets.js" charset="UTF-8"></script>\' sandbox="allow-scripts allow-same-origin allow-popups" height="527" width="640" scrolling="yes"></iframe>');
            case "tiktok":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" width="640" height="360" srcdoc=\'<blockquote class="tiktok-embed" data-video-id="').concat(id, '" style="max-width: 605px;min-width: 325px;" > <section> <a target="_blank"></a> <a target="_blank"></a> <a></a> <a></a> </section> </blockquote> <script async src="https://www.tiktok.com/embed.js"></script>\'>\n              </iframe>');
            case "vimeo":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" title="vimeo-player" src="https://player.vimeo.com/video/').concat(id, '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');
            case "telegram":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" width="640" height="360" srcdoc=\'<div><script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-post="').concat(id, '" data-width="100%"></script></div>\'></iframe>');
            case "facebook-messenger":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2F_%2Fvideos%2F').concat(id, '%2F&width=500&show_text=false&height=626&appId" width="500" height="626" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>');
            case "facebook-post":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F_%2Fphotos%2F_%2F').concat(id, '%2F%3Ftype%3D3&show_text=true&width=500" width="500" height="523" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>');
            case "linkedin":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" src="https://www.linkedin.com/embed/feed/update/urn:li:share:').concat(id, '" height="841" width="504" frameborder="0" allowfullscreen="" title="Publica\xe7\xe3o incorporada"></iframe>');
            case "spotify-track":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" style="border-radius:12px" src="https://open.spotify.com/embed/track/').concat(id, '?utm_source=generator" width="300" height="380" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>');
            case "spotify-playlist":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" style="border-radius:12px" src="https://open.spotify.com/embed/playlist/').concat(id, '?utm_source=generator" width="300" height="380" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>');
            case "spotify-podcast":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" style="border-radius:12px" src="https://open.spotify.com/embed/episode/').concat(id, '?utm_source=generator" width="100%" height="232" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>');
            case "scribd":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" class="scribd_iframe_embed" src="https://www.scribd.com/embeds/').concat(id, '/content?start_page=1&view_mode=scroll&access_key=key-GmUWwEZXun6XOYmbQMHM" tabindex="0" data-auto-height="true" data-aspect-ratio="0.7080062794348508" scrolling="no" width="100%" height="600" frameborder="0"></iframe>');
            case "infogram":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" src="https://e.infogram.com/').concat(id, '?src=embed" width="100%" height="300" scrolling="yes" frameborder="0" style="border:none;" allowfullscreen="allowfullscreen"></iframe>');
            case "threads":
                return '<iframe id="'.concat(type, "-").concat(id, '" loading="lazy" width="640" height="536" srcdoc=\'<blockquote class="text-post-media" data-text-post-permalink="https://www.threads.net/').concat(getAuthor(), "/post/").concat(id, '" data-text-post-version="0"></blockquote><script async="" src="https://www.threads.net/embed.js"></script>\'></iframe>');
            default:
                console.warn("Unexpected embed type: ", type);
                return "";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
        height: 100,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                tipo: "html",
                valor: [
                    getEmbed()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoResize, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/CustomComponentComposer/index.tsx
/* eslint-disable react/destructuring-assignment */ 









var DealsContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4285).then(__webpack_require__.bind(__webpack_require__, 4285));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4285)
            ];
        }
    },
    ssr: false
});
var customComponentTypes = [
    "embed",
    "pros-e-contras",
    "imagem",
    "citacao",
    "aspas",
    "galeria",
    "oferta-zoom"
];
var isCustomComponent = function(partHtml) {
    return customComponentTypes.includes(partHtml.tipo);
};
function CustomComponentComposer(param) {
    var partHtml = param.partHtml, index = param.index, _titulo = param.titulo, titulo = _titulo === void 0 ? "" : _titulo;
    var state = (0,react.useContext)(pageData/* default */.Z);
    switch(partHtml.tipo){
        case "imagem":
            {
                var caption = (partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda) && (partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda.length) > 0 && typeof (partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda) === "string" ? partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda : Array.isArray(partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda) && (partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda[0]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-0 mb-6 mt-0 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: partHtml.url,
                        srcsetString: partHtml === null || partHtml === void 0 ? void 0 : partHtml.srcset,
                        sizes: partHtml === null || partHtml === void 0 ? void 0 : partHtml.sizes,
                        width: partHtml === null || partHtml === void 0 ? void 0 : partHtml.width,
                        height: partHtml === null || partHtml === void 0 ? void 0 : partHtml.height,
                        blurhash: partHtml === null || partHtml === void 0 ? void 0 : partHtml.blurhash,
                        figcaption: partHtml === null || partHtml === void 0 ? void 0 : partHtml.legenda,
                        alt: (partHtml === null || partHtml === void 0 ? void 0 : partHtml.alt) || typeof caption === "string" && caption || titulo
                    })
                });
            }
        case "pros-e-contras":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProsAndCons/* default */.Z, {
                    pros: partHtml.pros,
                    cons: partHtml.contras
                }, "pros-and-cons-".concat(index));
            }
        case "citacao":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBlockquote, {
                    author: typeof partHtml.autor === "string" && partHtml.autor,
                    text: partHtml === null || partHtml === void 0 ? void 0 : partHtml.valor
                }, "blockquote-".concat(index));
            }
        case "galeria":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                    valor: partHtml === null || partHtml === void 0 ? void 0 : partHtml.valor
                }, "gallery-".concat(index));
            }
        case "embed":
            {
                if (partHtml.origem === "youtube") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameYoutube/* default */.Z, {
                        videoTitle: "",
                        videoId: partHtml.id,
                        isInternal: true,
                        timestamp: partHtml.timestamp
                    }, "video-".concat(index));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaEmbed, {
                    type: partHtml.origem,
                    id: partHtml.id,
                    hideDataConversation: partHtml.origem === "twitter" && partHtml.hideDataConversation === "1",
                    category: partHtml === null || partHtml === void 0 ? void 0 : partHtml.categoria,
                    author: partHtml === null || partHtml === void 0 ? void 0 : partHtml.autor
                }, "".concat(partHtml.origem, "-").concat(index));
            }
        case "oferta-zoom":
            {
                var ref, ref1, ref2, ref3;
                if (((ref = state.pageData) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.precos) && ((ref2 = state.pageData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.precos.length) > 0) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsContent, {
                        deals: state.pageData.data.precos.slice(0, 3),
                        produto: state.pageData.data.precos[0].produto
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            }
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
}


/***/ }),

/***/ 4486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderImageComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/utils/className.ts
var utils_className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Internals/HeaderImage/Image/styles.tsx
/* eslint-disable import/prefer-default-export */ 




var variants = {
    ContainerImage: {
        hasTarja: {
            true: "hasTarja [&_img]:[&.hasTarja]:rounded-t-none [&.hasTarja]:rounded-t-none",
            false: ""
        },
        isHeader: {
            internal: "[&_img]:aspect-video",
            full: "[&_img]:aspect-video [&_img]:tablet:aspect-[3/1]"
        }
    }
};
var ContainerImage = function(_param) /*#__PURE__*/ {
    var children = _param.children, hasTarja = _param.hasTarja, isHeader = _param.isHeader, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "hasTarja",
        "isHeader",
        "className"
    ]);
    return (0,jsx_runtime.jsx)("figure", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("relative h-full w-full overflow-hidden rounded [&_canvas]:block [&_canvas]:aspect-video [&_canvas]:h-full [&_canvas]:w-full [&_canvas]:rounded [&_img]:block [&_img]:aspect-video [&_img]:h-full [&_img]:w-full [&_img]:rounded [&_img]:object-cover", hasTarja != null && variants.ContainerImage.hasTarja[hasTarja.toString()], isHeader != null && variants.ContainerImage.isHeader[isHeader], className)
    }, rest), {
        children: children
    }));
};
var CaptionImage = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("figcaption", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "absolute bottom-4 right-4 max-w-[calc(100%-32px)] bg-[rgb(23,23,23)]/50 px-2 py-1 text-center text-[0.625rem] text-xs font-light text-mglGray300 before:text-mglGray300 before:content-['Imagem:_'] [&_a]:cursor-pointer [&_a]:text-mglBlue600 [&_a]:text-opacity-100 [&_a]:no-underline [&_a]:shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] [&_a]:transition-all [&_a]:duration-500 hover:[&_a]:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]"
    }, rest), {
        children: children
    }));
};

// EXTERNAL MODULE: ./src/components/Internals/HeaderImage/index.tsx
var HeaderImage = __webpack_require__(8964);
;// CONCATENATED MODULE: ./src/components/Internals/HeaderImage/Image/index.tsx
/* eslint-disable react/no-unknown-property */ /* eslint-disable react/jsx-props-no-spreading */ 








function HeaderImageComponent(param) {
    var src = param.src, alt = param.alt, _figcaption = param.figcaption, figcaption = _figcaption === void 0 ? undefined : _figcaption, _srcset = param.srcset, srcset = _srcset === void 0 ? undefined : _srcset, _width = param.width, width = _width === void 0 ? undefined : _width, _height = param.height, height = _height === void 0 ? undefined : _height, _hasTarja = param.hasTarja, hasTarja = _hasTarja === void 0 ? undefined : _hasTarja, _isHeader = param.isHeader, isHeader = _isHeader === void 0 ? undefined : _isHeader;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var imageComponentSpan = currentSpan && currentSpan.startChild({
        op: "imageComponent",
        description: src
    });
    var headerProps = {};
    if (isHeader) Object.assign(headerProps, {
        isHeader: isHeader
    });
    var image = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        style: {
            width: width || "100%",
            height: height || "100%"
        },
        hasTarja: !!hasTarja
    }, headerProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                src: src,
                ref: image,
                // Filtra entradas inválidas antes de montar o srcset:
                // - URL vazia/undefined → entrada viraria ` ${width}w` (sem URL), o
                //   browser interpreta a width sozinha como URL relativa e quebra a img.
                // - Chave fora do `srcSetDictionary` (ex.: backend retorna `1500` ou
                //   `2560`) → atributo viraria `url undefinedw`, inválido.
                srcSet: srcset ? Object.entries(srcset).filter(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], url = _param[1];
                    return Boolean(url) && HeaderImage/* srcSetDictionary */.o[key] !== undefined;
                }).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], url = _param[1];
                    return "".concat(url, " ").concat(HeaderImage/* srcSetDictionary */.o[key], "w");
                }).join(", ") || undefined : undefined,
                sizes: "(max-width: 992px) 100vw, 60vw",
                alt: alt,
                width: width && width,
                height: height && height,
                decoding: "async"
            }, {
                fetchpriority: "high"
            })),
            figcaption && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CaptionImage, {
                children: [
                    figcaption && figcaption !== undefined && figcaption.length > 0 && typeof figcaption === "string" ? figcaption : Array.isArray(figcaption) && (figcaption === null || figcaption === void 0 ? void 0 : figcaption.map(function(figcapitem, id) {
                        // eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: figcapitem && typeof figcapitem === "string" && (figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.length) > 0 ? figcapitem : typeof figcapitem === "object" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                                tipo: figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.tipo,
                                url: figcapitem.url,
                                as: figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.tag,
                                valor: figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.valor,
                                target: figcapitem.target
                            })
                        }, "".concat(typeof figcapitem === "string" ? figcapitem : figcapitem.valor, "-").concat(id));
                    })),
                    imageComponentSpan && imageComponentSpan.finish()
                ]
            })
        ]
    }));
}


/***/ }),

/***/ 8964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeaderImage; },
/* harmony export */   "o": function() { return /* binding */ srcSetDictionary; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5877);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4486);
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable react/no-unknown-property */ 




// Catálogo de larguras aceitas para gerar descritores `w` no `srcset`
// compatíveis com as derivações de imagem entregues pela API. Cada chave
// é o próprio `w` declarado — alinhado com o `IMAGE_SRCSET` do servidor.
var srcSetDictionary = {
    320: 320,
    640: 640,
    768: 768,
    1024: 1024,
    1200: 1200
};
function HeaderImage(param) {
    var url = param.url, alt = param.alt, caption = param.caption, srcset = param.srcset, _hasTarja = param.hasTarja, hasTarja = _hasTarja === void 0 ? undefined : _hasTarja, _isHeader = param.isHeader, isHeader = _isHeader === void 0 ? undefined : _isHeader;
    var ref;
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var headerImageSpan = currentSpan && currentSpan.startChild({
        op: "headerImage"
    });
    var imageProps = {};
    if (srcset) {
        Object.assign(imageProps, {
            imagesizes: "(max-width: 992px) 100vw, 60vw",
            imagesrcset: Object.keys(srcset).map(function(e) {
                return " ".concat(srcset[e], " ").concat(srcSetDictionary[e], "w");
            })
        });
    }
    // Fallback degradante para o `alt` do leitor de tela:
    //   1. `alt` explícito quando truthy após `trim` (matéria do Directus com
    //      texto curado/auto-importado, ou string informativa vinda do `NewsItem`);
    //   2. `caption` quando for string simples (compat com callers institucionais
    //      que passam apenas `caption`);
    //   3. `''` quando `caption` é array de `ComponentProps` (caption rica não
    //      serializa de forma útil como `alt` — `.toString()` produziria
    //      `'[object Object]'`).
    // `trim()` evita que valores só com whitespace (CMS frequentemente emite
    // strings tipo `'   '`) sejam truthy e bloqueiem o fallback semântico.
    var trimmedAlt = typeof alt === "string" ? alt.trim() : "";
    var trimmedCaption = typeof caption === "string" ? caption.trim() : "";
    var accessibleAlt = trimmedAlt || trimmedCaption;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mx-0 mb-6 mt-0 w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    rel: "preload",
                    as: "image",
                    href: url
                }, imageProps, {
                    fetchpriority: "high"
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: url,
                alt: accessibleAlt,
                figcaption: caption,
                srcset: srcset,
                hasTarja: hasTarja,
                isHeader: isHeader
            }),
            headerImageSpan && headerImageSpan.finish()
        ]
    });
}


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_7": function() { return /* binding */ DivContentNews; },
/* harmony export */   "xJ": function() { return /* binding */ TableContainer; }
/* harmony export */ });
/* unused harmony export Ad */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);





var DivContentNews = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        id: "content-news",
        ref: ref
    }, rest), {
        children: children
    }));
});
var TableContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: "mb-6 overflow-x-auto"
    }, rest), {
        children: children
    }));
};
var Ad = function(_param) {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: "relative mb-4 flex w-full justify-center p-0 text-center"
    }, rest), {
        children: children
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 3251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IFrameYoutube; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5877);
/* harmony import */ var _components_Internals_HeaderImage_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4486);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1216);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9659);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9642);








// Prefixo do aria-label do botão de play. Compartilhado entre o componente
// (`aria-label={`${PLAY_BUTTON_ARIA_PREFIX}: ${videoTitle}`}`) e o teste
// (`screen.getByRole('button', { name: ... })`) para evitar drift textual.
var PLAY_BUTTON_ARIA_PREFIX = "Reproduzir v\xeddeo";
function IFrameYoutube(param) {
    var videoTitle = param.videoTitle, videoId = param.videoId, _lazy = param.lazy, lazy = _lazy === void 0 ? true : _lazy, _isInternal = param.isInternal, isInternal = _isInternal === void 0 ? false : _isInternal, _capa = param.capa, capa = _capa === void 0 ? null : _capa, _timestamp = param.timestamp, timestamp = _timestamp === void 0 ? 0 : _timestamp;
    var ref;
    var variants = {
        VideoContainer: {
            isInternal: {
                true: "mb-6",
                false: ""
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var iframeYoutubeSpan = currentSpan && currentSpan.startChild({
        op: "iframeYoutube",
        description: videoTitle || videoId
    });
    var imageRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var getLargestImage = function(width) {
        // Guard: `useRef` sem valor inicial → `current` é `HTMLImageElement | undefined`
        // até o `<img ref>` montar. Acesso direto sem guard explode em runtime se
        // chamado antes do mount (improvável pelo fluxo atual, mas defensivo).
        if (width < 400 && imageRef.current) {
            imageRef.current.src = "https://img.youtube.com/vi/".concat(videoId, "/mqdefault.jpg");
        }
    };
    // `isActive` vira `true` quando o usuário clica no overlay de play.
    // Esse gesto explícito satisfaz a policy de autoplay com som dos browsers
    // (Chrome/Safari), então `autoplay=1` no src do iframe criado dentro do
    // handler de clique não é bloqueado — o vídeo começa em 1 clique em vez
    // de 2. Path `!lazy` continua sem autoplay porque iframe monta sem gesto
    // do usuário, cenário em que o browser bloquearia o som mesmo.
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isActive = ref1[0], setIsActive = ref1[1];
    var iframeSrc = "https://www.youtube.com/embed/".concat(videoId, "?start=").concat(timestamp).concat(isActive ? "&autoplay=1" : "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("divIframeYt relative mb-10 w-full overflow-hidden after:block after:pt-[56.25%] after:content-['']", variants.VideoContainer.isInternal[isInternal.toString()]),
        children: isActive || !lazy ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            className: "absolute left-0 top-0 h-full w-full",
            width: "100%",
            height: "100%",
            src: iframeSrc,
            title: videoTitle,
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            // Finaliza o span Sentry quando o iframe efetivamente carrega — o
            // momento certo (representa "tempo até iframe pronto"). Antes era
            // chamado dentro do branch da thumbnail (renderizado ANTES do
            // iframe), gerando span sem fim correto.
            onLoad: function() {
                return iframeYoutubeSpan && iframeYoutubeSpan.finish();
            }
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            id: videoId,
            "data-embed": videoId,
            children: [
                capa ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "absolute left-0 top-0 h-full w-full filter-none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "preload",
                                as: "image",
                                href: capa.url
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Internals_HeaderImage_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            src: capa.url,
                            alt: videoTitle,
                            srcset: capa.srcset
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    height: 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "absolute left-[-1%] top-[-18%] h-auto w-[102%] blur-sm",
                        ref: imageRef,
                        src: "https://img.youtube.com/vi/".concat(videoId, "/hqdefault.jpg"),
                        onLoad: function(e) {
                            getLargestImage(e.currentTarget.naturalWidth);
                        },
                        alt: videoTitle
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "focus-visible:ring-mglBlue absolute inset-0 z-[1] m-0 cursor-pointer appearance-none border-0 bg-transparent p-0 focus-visible:outline-none focus-visible:ring-2",
                    type: "button",
                    "aria-label": "".concat(PLAY_BUTTON_ARIA_PREFIX, ": ").concat(videoTitle),
                    onClick: function() {
                        return setIsActive(true);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute left-[50%] top-[50%] block h-12 w-[68px] [transform:translate3D(-50%,-50%,0)]",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            height: "100%",
                            version: "1.1",
                            viewBox: "0 0 68 48",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z",
                                    fill: "#F00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M 45,24 27,14 27,34",
                                    fill: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_5__/* .mglGray.mglGray50 */ .Ce.mglGray50
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 2153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImageComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-blurhash/es/index.js + 6 modules
var es = __webpack_require__(629);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/utils/className.ts
var utils_className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Layout/Image/styles.tsx
// /* eslint-disable import/prefer-default-export */





var ContainerImage = function(_param) {
    var children = _param.children, className = _param.className, _rounded = _param.rounded, rounded = _rounded === void 0 ? true : _rounded, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "rounded"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("ContainerImage flex w-full flex-col gap-y-2 [&_canvas]:block [&_canvas]:h-full [&_canvas]:w-full [&_div]:h-full [&_img]:[&_div]:block [&_img]:[&_div]:h-full [&_img]:[&_div]:w-full", className, rounded && "[&_canvas]:rounded [&_div]:rounded [&_img]:[&_div]:rounded")
    }, rest), {
        children: children
    }));
};
var CaptionImage = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "px-2 pb-0 pt-2 text-center text-xs font-light text-mglGray500 [&_a]:cursor-pointer [&_a]:text-mglBlue600 [&_a]:text-opacity-100 [&_a]:no-underline [&_a]:shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] [&_a]:transition-all [&_a]:duration-500 hover:[&_a]:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]"
    }, rest), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/Layout/Image/index.tsx
/* eslint-disable react/jsx-props-no-spreading */ 








function ImageComponent(param) {
    var src = param.src, _blurhash = param.blurhash, blurhash = _blurhash === void 0 ? undefined : _blurhash, alt = param.alt, _title = param.title, title = _title === void 0 ? undefined : _title, _figcaption = param.figcaption, figcaption = _figcaption === void 0 ? undefined : _figcaption, _srcset = param.srcset, srcset = _srcset === void 0 ? undefined : _srcset, _srcsetString = param.srcsetString, srcsetString = _srcsetString === void 0 ? undefined : _srcsetString, _sizes = param.sizes, sizes = _sizes === void 0 ? undefined : _sizes, _width = param.width, width = _width === void 0 ? undefined : _width, _height = param.height, height = _height === void 0 ? undefined : _height, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "object-cover" : _objectFit, _rounded = param.rounded, rounded = _rounded === void 0 ? true : _rounded;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var imageComponentSpan = currentSpan && currentSpan.startChild({
        op: "imageComponent",
        description: src
    });
    var ref1 = (0,react.useState)(false), hasLoaded = ref1[0], setHasLoaded = ref1[1];
    // F2.5: prioriza `srcsetString` quando presente (inline corpo).
    var finalSrcset = srcsetString !== null && srcsetString !== void 0 ? srcsetString : srcset ? Object.keys(srcset).map(function(e) {
        return "".concat(srcset[e], " ").concat(e, "w");
    }).join(", ") : undefined;
    var finalSizes = sizes !== null && sizes !== void 0 ? sizes : srcset ? Object.keys(srcset).map(function(e) {
        return "(max-width: ".concat(e, "px) ").concat(e, "px");
    }).join(", ") : undefined;
    // F2.5: quando `srcsetString` está setado (caminho inline), as dimensões
    // intrínsecas da imagem podem ser enormes (ex.: 6000×4000). Não propagar para
    // o `<figure>` — Tailwind `w-full` controla o container. Mantemos o
    // comportamento legado (width/height vão pro container) só para o caminho
    // capa/card, que passa dimensões pequenas e historicamente pinta a área.
    var inlineMode = srcsetString !== undefined;
    var containerStyle = inlineMode ? undefined : {
        width: width || "100%",
        height: height || "100%"
    };
    // Inline: placeholder reserva a área pela proporção, não pela altura intrínseca (2592px abriria buraco no mobile).
    var intrinsicRatio = width && height ? "".concat(width, " / ").concat(height) : undefined;
    var inlinePlaceholder = inlineMode && intrinsicRatio ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "aria-hidden": true,
        className: "w-full",
        style: {
            aspectRatio: intrinsicRatio
        }
    }) : undefined;
    // O CSS estica o canvas do blurhash pro tamanho visual; cap de resolução evita decodar na dimensão intrínseca.
    var blurhashWidth = width ? Math.min(width, 64) : 64;
    var blurhashHeight = width && height ? Math.max(1, Math.round(blurhashWidth * (height / width))) : 36;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerImage, {
        style: containerStyle,
        rounded: rounded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
            className: "h-full rounded",
            height: inlinePlaceholder ? undefined : height || 1,
            placeholder: inlinePlaceholder,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    src: src
                }, finalSrcset ? {
                    srcSet: finalSrcset
                } : {}, finalSizes ? {
                    sizes: finalSizes
                } : {}), {
                    alt: alt,
                    title: title || alt,
                    onLoad: function() {
                        return setHasLoaded(true);
                    },
                    width: width && width,
                    height: height && height,
                    style: !hasLoaded ? {
                        display: "none"
                    } : null,
                    // `max-w-full` é defensivo: quando o caller (ex.: imagem inline do conteúdo
                    // editorial) não passa width/height nem srcset, o browser renderia no naturalWidth
                    // (4000px+ no Thumbor com `width=0`) e estouraria o container do artigo (~700px).
                    // Não usar `h-auto` pq sobrescreveria o atributo HTML `height` em cards 1:1 forçados
                    // (Product/Header, FeaturedDeals) — sem altura explícita, browser preserva aspect natural.
                    className: "max-w-full ".concat(objectFit)
                })),
                !hasLoaded && blurhash && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* BlurhashCanvas */.c, {
                    hash: blurhash,
                    width: blurhashWidth,
                    height: blurhashHeight,
                    punch: 1
                }),
                figcaption && /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptionImage, {
                    children: figcaption && figcaption !== undefined && figcaption.length > 0 && typeof figcaption === "string" ? figcaption : Array.isArray(figcaption) && (figcaption === null || figcaption === void 0 ? void 0 : figcaption.map(function(figcapitem, id) {
                        // eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: figcapitem && typeof figcapitem === "string" && (figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.length) > 0 ? figcapitem.charAt(0).toUpperCase() + figcapitem.slice(1) : typeof figcapitem === "object" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                                tipo: figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.tipo,
                                url: figcapitem.url,
                                as: figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.tag,
                                valor: figcapitem === null || figcapitem === void 0 ? void 0 : figcapitem.valor,
                                target: figcapitem.target
                            })
                        }, "".concat(typeof figcapitem === "string" ? figcapitem : figcapitem.valor, "-").concat(id));
                    }))
                }),
                imageComponentSpan && imageComponentSpan.finish()
            ]
        })
    });
}


/***/ }),

/***/ 4879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProsAndCons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5877);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6008);



function ProsAndCons(param) {
    var pros = param.pros, cons = param.cons;
    var ref;
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var prosAndConsSpan = currentSpan && currentSpan.startChild({
        op: "prosAndCons"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pros-cons-section mb-6 flex flex-col gap-8",
        children: [
            !!(pros === null || pros === void 0 ? void 0 : pros.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pros-cons w-full rounded border border-solid border-mglGray200",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pros-cons-div-title bg-mglGray200 px-6 py-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-[1.5rem] font-medium leading-none",
                            children: "Pr\xf3s"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "list-none p-4",
                        children: pros.map(function(pro) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "h-[18px] w-[18px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            icon: "mdi:arrow-right",
                                            color: "#00bfa5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "px-0 py-2 text-lg leading-none text-[#2B2B2B]",
                                        children: pro
                                    })
                                ]
                            }, pro);
                        })
                    })
                ]
            }),
            !!(cons === null || cons === void 0 ? void 0 : cons.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pros-cons w-full rounded border border-solid border-mglGray200",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pros-cons-div-title bg-mglGray200 px-6 py-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-[1.5rem] font-medium leading-none",
                            children: "Contras"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "list-none p-4",
                        children: cons.map(function(con) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "h-[18px] w-[18px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            icon: "mdi:arrow-right",
                                            color: "#F63D6A"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "px-0 py-2 text-lg leading-none text-[#2B2B2B]",
                                        children: con
                                    })
                                ]
                            }, con);
                        })
                    })
                ]
            }),
            prosAndConsSpan && prosAndConsSpan.finish()
        ]
    });
}


/***/ }),

/***/ 6425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOutsideClickRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useOutsideClickRef(param) {
    var setIsOpen = param.setIsOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handleClickOutside = function(event) {
        var ref1;
        if (!(ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event === null || event === void 0 ? void 0 : event.target))) {
            setIsOpen(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            return document.removeEventListener("click", handleClickOutside, true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref
    ]);
    return ref;
}


/***/ })

}]);